@import "@SeemplicityDev/shared/src/design-system/styles/constants.scss";

.tabs-menu-wrapper {
  width: 100%;
  position: relative;

  &.align-left .sub-menu-item-title {
    padding-left: 0 !important;
  }

  .menu-underline {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 2px;
    background-color: var(--tabs-bottom-border-color);
    width: 100%;
  }

  .menu-tabs {
    display: flex;

    .tab-item-wrapper {
      display: flex;
      align-items: flex-start;
      gap: var(--spacing-2);
      margin-right: var(--spacing-4);
      cursor: pointer;

      &.has-badge .sub-menu-item-title {
        padding-right: 0 !important;
      }
    }

    .sub-header-menu-item-link {
      color: var(--tabs-text-color);
      font-weight: 500;
      font-size: var(--font-size-s);
      line-height: 20px;
      transition: color ease-in-out 0.2s;
      @include ellipsis(100%);

      .sub-menu-item-label {
        .sub-menu-item-title {
          @include subtitle-typography;
          padding-inline: var(--spacing-3) var(--spacing-4);
          cursor: pointer;
        }

        &.has-left-img {
          display: flex;
          gap: var(--spacing-2);
          align-items: center;

          img {
            height: var(--icon-size-s);
            width: var(--icon-size-s);
            flex: 0 0 var(--spacing-4);
          }

          .sub-menu-item-title {
            padding-left: var(--spacing-2);
          }
        }

        .info-icon {
          align-self: center;
          color: var(--text-color-strong);
        }
      }

      .sub-item-underline {
        position: relative;
        z-index: 1;
        border-top-left-radius: var(--border-radius-xs);
        border-top-right-radius: var(--border-radius-xs);
        width: 100%;
        height: 2px;
        margin-top: var(--spacing-3);
        opacity: 0;
        transition:
          opacity ease-in-out 0.2s,
          background-color ease-in-out 0.2s;
      }

      &.active {
        color: var(--tabs-text-color-active);
        .sub-item-underline {
          opacity: 1;
          background-color: var(--tabs-text-color-active);
        }
      }
    }

    .tab-item-wrapper:hover .sub-header-menu-item-link {
      color: var(--tabs-text-color-hover);

      .sub-item-underline {
        background-color: var(--tabs-text-color-hover);
      }
    }
  }
  &.is-dark {
    .sub-header-menu-item-link {
      color: var(--tabs-dark-text-color);

      &.active {
        color: var(--tabs-dark-text-color-active);
        .sub-item-underline {
          opacity: 1;
          background-color: var(--tabs-dark-text-color-active);
        }
      }

      &.disabled {
        color: var(--tabs-dark-text-color-disabled);
      }
    }

    .tab-item-wrapper:hover .sub-header-menu-item-link {
      color: var(--tabs-dark-text-color-hover);
    }

    .menu-underline {
      background-color: var(--tabs-dark-bottom-border-color);
    }
  }
}
.actions-menu .filter-selection-container .tabs-menu-wrapper {
  padding-top: 5px;
}
